// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-mdx": () => import("/Users/raul/github/using-gatsby-mdx-remark-images/src/pages/index.mdx" /* webpackChunkName: "component---src-pages-index-mdx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/raul/github/using-gatsby-mdx-remark-images/.cache/data.json")

